import { create } from 'zustand';
import store from 'store2';
import isNil from 'lodash.isnil';

export const AUTH_STORAGE_KEY = 'mevivo/auth-token';

export interface AuthState {
    /** The token */
    token?: string;
    /** If the auth is currently invalid */
    authInvalid?: boolean;
}

export interface AuthActions {
    /** Sets the auth token */
    setAuthToken: (token: string) => void;
    /** Expires the token */
    expireToken: () => void;
    /** Returns true if the app is currently authenticated */
    isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState & AuthActions>()((set, get) => ({
    token: store.get(AUTH_STORAGE_KEY),
    expireToken: () => {
        set({ token: undefined, authInvalid: true });
        store.remove(AUTH_STORAGE_KEY);
    },
    setAuthToken: (val) => {
        store.set(AUTH_STORAGE_KEY, val);
        set({ token: val, authInvalid: false });
    },
    isAuthenticated: () => {
        return !isNil(get().token);
    },
}));
